import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ticket: "",
  tickets: "",
};

const ticketSlice = createSlice({
  name: "ticket",
  initialState: initialState,
  reducers: {
    setTicket(state, payload) {
      state.ticket = payload.payload.response;
    },
    getTickets(state, payload) {
      state.tickets = payload.payload.response;
    },
    alert(state, action) {
      state.error = action.payload;
    },
  },
});

export default ticketSlice.reducer;
export const ticketActions = ticketSlice.actions;
